var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/arrow-right"),React.createElement("g",{"id":"icon/arrow-right","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path","fill":"#1D1655","fillRule":"nonzero","points":"16 1 13.17 3.64133333 24.34 14.0666667 0 14.0666667 0 17.8 24.34 17.8 13.17 28.2253333 16 30.8666667 32 15.9333333"}))]);
}

ArrowRight.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
